import React from "react";
import { SHORT_COLOR } from "@components/pages/Futures/components/Controls/TradeForm/constants";

const RiskErrorIcon = ({ size = 20, color = SHORT_COLOR }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M10 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14m0-10.5c.364 0 .656.293.656.656v3.063a.655.655 0 0 1-.656.656.655.655 0 0 1-.656-.656V7.156c0-.363.292-.656.656-.656m-.875 6.125a.875.875 0 1 1 1.75 0 .875.875 0 0 1-1.75 0"
      fill={color}
    />
  </svg>
);

export default RiskErrorIcon;
